import {
	TGetForeignSystemHistoryUpdateUnitListResponse,
	TGetForeignSystemUnitListResponse,
} from '@/services';

import { formatDate, map } from 'utils';

export const formatForeignSystemUnitDetail = (
	input: TGetForeignSystemUnitListResponse['content'][number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt) || '',
		updateDt: formatDate(input.updateDt) || '',
	};
};

export const formatForeignSystemUnitList = (
	input: TGetForeignSystemUnitListResponse['content']
) => {
	return map(input, formatForeignSystemUnitDetail);
};

export const formatHistoryUpdateForeignUnitDetail = (
	input: TGetForeignSystemHistoryUpdateUnitListResponse['content'][number]
) => {
	return {
		...input,
	};
};

export const formatHistoryUpdateForeignUnitList = (
	input: TGetForeignSystemHistoryUpdateUnitListResponse['content']
) => {
	return map(input, formatHistoryUpdateForeignUnitDetail);
};
